"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Client = void 0;
const constants_1 = require("./constants");
const utils_1 = require("./utils");
class Client {
  constructor(options) {
    this.options = Object.assign(Object.assign({}, constants_1.defaultClientOptions), options || {});
    this.options.apiRoot = utils_1.stripTrailingSlash(this.options.apiRoot);
    // this.options.partnerid = this.options.partnerid;
    // this.options.appid = this.options.appid
    // this.options.token = this.options.token
  }
  setDomain(url) {
    this.options.apiRoot = url;
  }
  setToken(token) {
    this.options.token = token;
  }
  setPartner(partnerid) {
    this.options.partnerid = partnerid;
  }
  setAppId(appid) {
    this.options.appid = appid;
  }
  setCskhToken(cskhtoken) {
    this.options.cskhtoken = cskhtoken;
  }
  setOneSignal(osid, ostoken) {
    this.options.osid = osid;
    this.options.ostoken = ostoken;
  }
  setLocale(locale) {
    this.options.locale = locale;
  }
  setVersion(version) {
    this.options.version = version;
  }
  setPlatform(platform) {
    this.options.platform = platform;
  }
  setRefCode(refcode) {
    this.options.refcode = refcode;
  }
  getOptions() {
    return this.options;
  }
  setDeviceModel(deviceModel) {
    this.options.deviceModel = deviceModel;
  }
  getDoctorTelemedRate(data, headers) {
    const url = `${this.options.apiRoot}/${constants_1.GET_DOCTOR_TELEMED_RATE}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'POST', headerConfig, data);
  }
  getHomePageData(headers) {
    const url = `${this.options.apiRoot}/${constants_1.GET_HOME_PAGE_DATA}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'POST', headerConfig, {});
  }
  // /**
  //  * GET ALL PAYMENT METHOD
  //  *
  //  *
  //  * @param {CreateNotificationBody} body Request body.
  //  * @returns {Promise<Response>} Http response of One Signal server.
  //  */
  // eslint-disable-next-line class-methods-use-this
  getAllPaymentMethod(query, headers) {
    const queryString = utils_1.jsonToQueryString(query);
    const url = `${this.options.apiRoot}/${constants_1.GET_ALL_PAYMENT_METHOD}?${queryString}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'GET', headerConfig);
  }
  createUserAccount(data, headers) {
    const url = `${this.options.apiRoot}/${constants_1.USER_ACCOUNT_CREATE_ACCOUNT}/${data.patientCode}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'GET', headerConfig);
  }
  userAccountsDetail(headers) {
    const url = `${this.options.apiRoot}/${constants_1.USER_ACCOUNT_GET_DETAIL}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'GET', headerConfig);
  }
  getPaymentRequestForPatient(headers) {
    const url = `${this.options.apiRoot}/${constants_1.USER_ACCOUNT_REQUEST_PAYMENT_FOR_PATIENT}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'GET', headerConfig);
  }
  getBalance(data, headers) {
    const url = `${this.options.apiRoot}/${constants_1.USER_ACCOUNT_GET_BALANCE}/${data.patientCode}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'GET', headerConfig);
  }
  getTransactions(data, headers) {
    const url = `${this.options.apiRoot}/${constants_1.USER_ACCOUNT_GET_TRANSACTIONS}/${data.patientCode}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'GET', headerConfig);
  }
  getTransactionDetail(data, headers) {
    const url = `${this.options.apiRoot}/${constants_1.USER_ACCOUNT_GET_TRANSACTION_DETAIL}/${data.accountId}/${data.transactionId}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'GET', headerConfig);
  }
  getBillInfo(data, headers) {
    const url = `${this.options.apiRoot}/${constants_1.USER_ACCOUNT_REQUEST_BILL_INFO}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'POST', headerConfig, data);
  }
  payHospitalFee(data, headers) {
    const url = `${this.options.apiRoot}/${constants_1.USER_ACCOUNT_PAY_HOSPITAL_FEE}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'POST', headerConfig, data);
  }
  getUserProfile(headers) {
    const url = `${this.options.apiRoot}/${constants_1.USER_PROFILE_DETAIL}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'POST', headerConfig, {});
  }
  checkCardAvailable(headers) {
    const url = `${this.options.apiRoot}/${constants_1.CHECK_AVAILABLE_CARD}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'POST', headerConfig, {});
  }
  payHospitalFeeByCard(data, headers) {
    const url = `${this.options.apiRoot}/${constants_1.USER_ACCOUNT_PAYMENT_FEE_BY_CARD}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'POST', headerConfig, data);
  }
  kiotCreateNewPIN(data, headers) {
    const url = `${this.options.apiRoot}/${constants_1.KIOT_CREATE_NEW_PIN}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'POST', headerConfig, data);
  }
  kiotChangePIN(data, headers) {
    const url = `${this.options.apiRoot}/${constants_1.KIOT_CHANGE_PIN}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'POST', headerConfig, data);
  }
  withdrawal(data, headers) {
    const url = `${this.options.apiRoot}/${constants_1.USER_ACCOUNT_WITHDRAWAL}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'POST', headerConfig, data);
  }
  examResult(data, headers) {
    const url = `${this.options.apiRoot}/${constants_1.CHORAY_EXAM_RESULT}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'POST', headerConfig, data);
  }
  getHealthHistories(data, headers) {
    const url = `${this.options.apiRoot}/${constants_1.CHORAY_GET_HEALTH_HISTORIES}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'POST', headerConfig, data);
  }
  getHistoryExamByUser(headers) {
    const url = `${this.options.apiRoot}/${constants_1.HISTORY_EXAM_BY_USER}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'GET', headerConfig);
  }
  getHistoryExamByPatient(data, headers) {
    const url = `${this.options.apiRoot}/${constants_1.HISTORY_EXAM_BY_PATIENT}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'POST', headerConfig, data);
  }
  getHistoryExamByExamId(data, headers) {
    const url = `${this.options.apiRoot}/${constants_1.HISTORY_EXAM}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'POST', headerConfig, data);
  }
  historyExamGroup(data, headers) {
    const url = `${this.options.apiRoot}/${constants_1.HISTORY_EXAM_GROUP}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'POST', headerConfig, data);
  }
  historyExamGroupDetail(data, headers) {
    const url = `${this.options.apiRoot}/${constants_1.HISTORY_EXAM_GROUP_DETAIL}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'POST', headerConfig, data);
  }
  getHealthExamHistories(data, headers) {
    const url = `${this.options.apiRoot}/${constants_1.CHORAY_GET_HEALTH_EXAM_HISTORIES}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'POST', headerConfig, data);
  }
  getDetailHealthHistory(data, headers) {
    const url = `${this.options.apiRoot}/${constants_1.CHORAY_GET_DETAIL_HEALTH_HISTORY}/${data.id}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'GET', headerConfig);
  }
  deposit(data, headers) {
    const url = `${this.options.apiRoot}/${constants_1.USER_ACCOUNT_DEPOSIT}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'POST', headerConfig, data);
  }
  isRequirePayment(data, headers) {
    const url = `${this.options.apiRoot}/${constants_1.CHECK_PAYMENT_METHOD_ZERO}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'POST', headerConfig, data);
  }
  checkUserInfoByPhone(data, headers) {
    const url = `${this.options.apiRoot}/${constants_1.CHECK_USER_INFO_BY_PHONE}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'POST', headerConfig, data);
  }
  getServicePackage(query, headers) {
    const queryString = utils_1.jsonToQueryString(query);
    const url = `${this.options.apiRoot}/${constants_1.GET_SERVICE_PACKAGE}?${queryString}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'GET', headerConfig);
  }
  viewServicePackage(query, headers) {
    const queryString = utils_1.jsonToQueryString(query);
    const url = `${this.options.apiRoot}/${constants_1.VIEW_SERVICE_PACKAGE}?${queryString}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'GET', headerConfig);
  }
  isVatInvoice(headers) {
    const url = `${this.options.apiRoot}/${constants_1.IS_VAT_INVOICE}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'GET', headerConfig);
  }
  reserveBooking(data, headers) {
    const url = `${this.options.apiRoot}/${constants_1.RESERVE_BOOKING}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'POST', headerConfig, data);
  }
  cbytLogin(data, headers) {
    const url = `${this.options.apiRoot}/${constants_1.USER_ACCOUNT_LOGIN}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'POST', headerConfig, data);
  }
  reserveMultipleBookings(data, headers) {
    const url = `${this.options.apiRoot}/${constants_1.RESERVE_MULTI_BOOKINGS}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'POST', headerConfig, data);
  }
  bookingShareToPay(data, headers) {
    const url = `${this.options.apiRoot}/${constants_1.BOOKING_SHARE_TO_PAY}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'POST', headerConfig, data);
  }
  rePaymentShareToPay(query, headers) {
    const queryString = utils_1.jsonToQueryString(query);
    const url = `${this.options.apiRoot}/${constants_1.RE_PAYMENT_SHARE_TO_PAY}?${queryString}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'GET', headerConfig);
  }
  rePaymentShareToPayByInfo(data, headers) {
    const url = `${this.options.apiRoot}/${constants_1.RE_PAYMENT_SHARE_TO_PAY}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'POST', headerConfig, data);
  }
  createPatientProfile(data, headers) {
    const url = `${this.options.apiRoot}/${constants_1.CREATE_PATIENT_PROFILE}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'POST', headerConfig, data);
  }
  getPatientProfiles(data, headers) {
    const url = `${this.options.apiRoot}/${constants_1.GET_PATIENT_PROFILES}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'POST', headerConfig, data);
  }
  createDeposit(data, headers) {
    const url = `${this.options.apiRoot}/${constants_1.USER_ACCOUNT_CREATE_DEPOSIT}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'POST', headerConfig, data);
  }
  updateEmployeeIdUserProfile(data, headers) {
    const url = `${this.options.apiRoot}/${constants_1.UPDATE_EMPLOYEEID_USER_PROFILE}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'POST', headerConfig, data);
  }
  updateEmployeeIdUserProfileToken(data, headers) {
    const url = `${this.options.apiRoot}/${constants_1.UPDATE_EMPLOYEEID_USER_PROFILE_TOKEN}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'POST', headerConfig, data);
  }
  reserveVaccine(data, headers) {
    const url = `${this.options.apiRoot}/${constants_1.RESERVE_VACCINE}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'POST', headerConfig, data);
  }
  createVaccineOrder(data, headers) {
    const url = `${this.options.apiRoot}/${constants_1.CREATE_ORDER_VACCINE}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'POST', headerConfig, data);
  }
  paymentFee(data, headers) {
    const url = `${this.options.apiRoot}/${constants_1.BOOKING_GATEWAY_PAYMENT_FEE}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'POST', headerConfig, data);
  }
  cancelBooking(query, headers) {
    const queryString = utils_1.jsonToQueryString(query);
    const url = `${this.options.apiRoot}/${constants_1.CANCEL_RESERVATION_BOOKING}?${queryString}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'GET', headerConfig);
  }
  getServiceInfo(query, headers) {
    const queryString = utils_1.jsonToQueryString(query);
    const url = `${this.options.apiRoot}/${constants_1.GET_SERVICE_INFO}?${queryString}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'GET', headerConfig);
  }
  getPaymentInfo(query, headers) {
    const queryString = utils_1.jsonToQueryString(query);
    const url = `${this.options.apiRoot}/${constants_1.GET_PAYMENT_INFO}?${queryString}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'GET', headerConfig);
  }
  getBookingWithTransactionCode(query, headers) {
    const queryString = utils_1.jsonToQueryString(query);
    const url = `${this.options.apiRoot}/${constants_1.GET_BOOKING_WITH_TRANSACTION_CODE}?${queryString}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'GET', headerConfig);
  }
  cskhGetBookingsTransaction(query, headers) {
    const queryString = utils_1.jsonToQueryString(query);
    const url = `${this.options.apiRoot}/${constants_1.CSKH_BOOKING_TRANSACTION}?${queryString}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'GET', headerConfig);
  }
  checkTransaction(data, headers) {
    const url = `${this.options.apiRoot}/${constants_1.CHECK_TRANSACTION}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'POST', headerConfig, data);
  }
  getAllBookingByUserId(headers) {
    const url = `${this.options.apiRoot}/${constants_1.GET_ALL_BOOKING_BY_USER_ID}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'GET', headerConfig);
  }
  getAllInvisibleBookingByUserId(headers) {
    const url = `${this.options.apiRoot}/${constants_1.GET_ALL_INVISIBLE_BOOKING_BY_USER_ID}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'GET', headerConfig);
  }
  invisibleBooking(query, headers) {
    const queryString = utils_1.jsonToQueryString(query);
    const url = `${this.options.apiRoot}/${constants_1.INVISIBLE_BOOKING}?${queryString}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'GET', headerConfig);
  }
  getAllBookingByCSKH(data, headers) {
    const url = `${this.options.apiRoot}/${constants_1.CSKH_ALL_SEARCH_BOOKING}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'POST', headerConfig, data);
  }
  getInfoByPhoneCSKH(data, headers) {
    const url = `${this.options.apiRoot}/${constants_1.CSKH_GET_INFO_BY_PHONE}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'POST', headerConfig, data);
  }
  getTransactionInfoCSKH(data, headers) {
    const url = `${this.options.apiRoot}/${constants_1.CSKH_GET_TRANSACTION_INFO}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'POST', headerConfig, data);
  }
  getInfoByPhoneCSKHV2(data, headers) {
    const url = `${this.options.apiRoot}/${constants_1.CSKH_GET_INFO_BY_PHONE_V2}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'POST', headerConfig, data);
  }
  getBookingInfoCSKH(data, headers) {
    const url = `${this.options.apiRoot}/${constants_1.CSKH_VIEW_BOOKING}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'POST', headerConfig, data);
  }
  getExtraConfig(headers) {
    const url = `${this.options.apiRoot}/${constants_1.GET_EXTRA_PARTNER_CONFIG}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'GET', headerConfig);
  }
  sendSMS(data, headers) {
    const url = `${this.options.apiRoot}/${constants_1.CSKH_SEND_SMS}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'POST', headerConfig, data);
  }
  /* KIOT */
  kiotGetCardInfo(data, headers) {
    const url = `${this.options.apiRoot}/${constants_1.KIOT_GET_CARD_INFO}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'POST', headerConfig, data);
  }
  kiotCardLogin(data, headers) {
    const url = `${this.options.apiRoot}/${constants_1.KIOT_CARD_INFO_LOGIN}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'POST', headerConfig, data);
  }
  isDepositRequired(data, headers) {
    const url = `${this.options.apiRoot}/${constants_1.USER_ACCOUNT_CHECK_DEPOSIT_BALANCE}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'POST', headerConfig, data);
  }
  getAllOrdersByUserId(headers) {
    const url = `${this.options.apiRoot}/${constants_1.GET_ORDERS_BY_USER}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'GET', headerConfig);
  }
  transactionTracking(headers) {
    const url = `${this.options.apiRoot}/${constants_1.USER_ACCOUNT_TRANSACTION_TRACKING}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'GET', headerConfig);
  }
  getFilterOrderCondition(headers) {
    const url = `${this.options.apiRoot}/${constants_1.GET_FILTER_ORDERS_CONDITION}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'GET', headerConfig);
  }
  getAllBookings(headers) {
    const url = `${this.options.apiRoot}/${constants_1.GET_ALL_BOOKING_2}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'POST', headerConfig, {});
  }
  getAllCovidBookings(data, headers) {
    const url = `${this.options.apiRoot}/${constants_1.GET_ALL_COVID_BOOKING}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'POST', headerConfig, data);
  }
  getAllInvisibleBookings(headers) {
    const url = `${this.options.apiRoot}/${constants_1.GET_ALL_INVISIBLE_BOOKING}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'POST', headerConfig, {});
  }
  getHolidays(headers) {
    const url = `${this.options.apiRoot}/${constants_1.GET_ALL_HOLIDAY}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'GET', headerConfig);
  }
  getSMSCode(data, headers) {
    const url = `${this.options.apiRoot}/${constants_1.CHECK_PHONE}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'POST', headerConfig, data);
  }
  checkSMSCode(data, headers) {
    const url = `${this.options.apiRoot}/${constants_1.CHECK_CODE}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'POST', headerConfig, data);
  }
  zaloLogin(data, headers) {
    const url = `${this.options.apiRoot}/${constants_1.ZALO_LOGIN}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'POST', headerConfig, data);
  }
  firebaseLogin(data, headers) {
    const url = `${this.options.apiRoot}/${constants_1.FIREBASE_LOGIN}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'POST', headerConfig, data);
  }
  khaiBaoYTeSubmitForm(data, headers) {
    const url = `${this.options.apiRoot}/${constants_1.KHAI_BAO_YTE_SUBMIT}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'POST', headerConfig, data);
  }
  khaiBaoYTeList(headers) {
    const url = `${this.options.apiRoot}/${constants_1.KHAI_BAO_YTE_LIST}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'POST', headerConfig, {});
  }
  getBookingTreev2(data, headers) {
    const url = `${this.options.apiRoot}/${constants_1.GET_BOOKING_TREE_V2}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'POST', headerConfig, data);
  }
  getBookingTreeDynamic(data, headers) {
    const url = `${this.options.apiRoot}/${constants_1.GET_BOOKING_TREE_DYNAMIC}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    const dataObj = data || {};
    return utils_1.basicAuthRequest(url, 'POST', headerConfig, dataObj);
  }
  getBookingTreeCurrentNode(data, headers) {
    const url = `${this.options.apiRoot}/${constants_1.GET_BOOKING_TREE_CURRENT_NODE}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'POST', headerConfig, data);
  }
  getBookingTree(headers) {
    const url = `${this.options.apiRoot}/${constants_1.GET_BOOKING_TREE}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'GET', headerConfig);
  }
  getRelationType(headers) {
    const url = `${this.options.apiRoot}/${constants_1.GET_RELATION_TYPE}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'GET', headerConfig);
  }
  createUserMomoByToken(headers) {
    const url = `${this.options.apiRoot}/${constants_1.CREATE_USER_BY_TOKEN}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'GET', headerConfig);
  }
  insertPatient(data, headers) {
    const url = `${this.options.apiRoot}/${constants_1.INSERT_PATIENT}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'POST', headerConfig, data);
  }
  insertPatientKiosk(data, headers) {
    const url = `${this.options.apiRoot}/${constants_1.INSERT_PATIENT_KIOSK}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'POST', headerConfig, data);
  }
  insertBasicInfo(data, headers) {
    const url = `${this.options.apiRoot}/${constants_1.INSERT_PATIENT_BASIC_INFO}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'POST', headerConfig, data);
  }
  getPatientsByUserId(data, headers) {
    const url = `${this.options.apiRoot}/${constants_1.GET_PATIENTS_BY_USER_ID}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'POST', headerConfig, data);
  }
  getPatientsByUserIdV2(headers) {
    const url = `${this.options.apiRoot}/${constants_1.GET_PATIENTS_BY_USER_ID_V2}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'GET', headerConfig);
  }
  updatePatientWithPatientCode(data, headers) {
    const url = `${this.options.apiRoot}/${constants_1.UPDATE_PATIENT_WITH_PATIENT_CODE}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'POST', headerConfig, data);
  }
  updatePatient(data, headers) {
    const url = `${this.options.apiRoot}/${constants_1.UPDATE_PATIENT_WITHOUT_PATIENT_CODE}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'POST', headerConfig, data);
  }
  cskhCheckSyncPatient(headers) {
    const url = `${this.options.apiRoot}/${constants_1.CSKH_CHECK_SYNC_PATIENT}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'POST', headerConfig, {});
  }
  updatePatientWithoutPatientCode(data, headers) {
    const url = `${this.options.apiRoot}/${constants_1.UPDATE_PATIENT_WITHOUT_PATIENT_CODE}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'POST', headerConfig, data);
  }
  findByMsbn(data, headers) {
    const url = `${this.options.apiRoot}/${constants_1.FIND_PATIENT_BY_MSBN}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'POST', headerConfig, data);
  }
  findByExtraInfo(data, headers) {
    const url = `${this.options.apiRoot}/${constants_1.FIND_PATIENT_BY_EXTRA}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'POST', headerConfig, data);
  }
  findByCMND(data, headers) {
    const url = `${this.options.apiRoot}/${constants_1.FIND_PATIENT_BY_CMND}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'POST', headerConfig, data);
  }
  verifyPhone(data, headers) {
    const url = `${this.options.apiRoot}/${constants_1.VERIFY_PHONE_FIND_PATIENT}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'POST', headerConfig, data);
  }
  verifyInsuranceCode(data, headers) {
    const url = `${this.options.apiRoot}/${constants_1.VERIFY_INSURANCE_CODE_FIND_PATIENT}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'POST', headerConfig, data);
  }
  addPatientIntoUser(data, headers) {
    const url = `${this.options.apiRoot}/${constants_1.ADD_PATIENT_INTO_USER_FIND_PATIENT}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'POST', headerConfig, data);
  }
  getPatientInfoToUpdate(query, headers) {
    const queryString = utils_1.jsonToQueryString(query);
    const url = `${this.options.apiRoot}/${constants_1.GET_PATIENT_DETAIL_FOR_UPDATE}?${queryString}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'GET', headerConfig);
  }
  unlinkPatient(query, headers) {
    const queryString = utils_1.jsonToQueryString(query);
    const url = `${this.options.apiRoot}/${constants_1.UNLINK_PATIENT}?${queryString}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'GET', headerConfig);
  }
  getAllNotifByUser(headers) {
    const url = `${this.options.apiRoot}/${constants_1.GET_ALL_NOTIF_BY_USER}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'GET', headerConfig);
  }
  getAllNotifByUserGroup(headers) {
    const url = `${this.options.apiRoot}/${constants_1.GET_ALL_NOTIF_BY_USER_GROUP}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'GET', headerConfig);
  }
  getAllUnReadNotifByUser(headers) {
    const url = `${this.options.apiRoot}/${constants_1.GET_ALL_NOTIF_BY_USER_UNREAD}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'GET', headerConfig);
  }
  markViewedNotif(query, headers) {
    const queryString = utils_1.jsonToQueryString(query);
    const url = `${this.options.apiRoot}/${constants_1.MARK_NOTIF_VIEWED}?${queryString}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'GET', headerConfig);
  }
  deleteNotif(query, headers) {
    const url = `${this.options.apiRoot}/${constants_1.DELETE_NOTIF}/${query.id}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'DELETE', headerConfig);
  }
  deleteAllNotif(headers) {
    const url = `${this.options.apiRoot}/${constants_1.DELETE_ALL_NOTIF}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'DELETE', headerConfig);
  }
  markViewAllNotif(headers) {
    const url = `${this.options.apiRoot}/${constants_1.MARK_VIEW_ALL_NOTIF}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'GET', headerConfig);
  }
  rePayment(query, headers) {
    const queryString = utils_1.jsonToQueryString(query);
    const url = `${this.options.apiRoot}/${constants_1.RE_PAYMENT}?${queryString}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'GET', headerConfig);
  }
  paymentFeeSearchCode(query, headers) {
    const queryString = utils_1.jsonToQueryString(query);
    const url = `${this.options.apiRoot}/${constants_1.PAYMENT_FEE_SEARCH_CODE}?${queryString}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'GET', headerConfig);
  }
  getFeatureByPartner(headers) {
    const url = `${this.options.apiRoot}/${constants_1.GET_FEATURE_BY_PARTNER}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'GET', headerConfig);
  }
  getTrungVuongFeatureV2(headers) {
    const url = `${this.options.apiRoot}/${constants_1.GET_FEATURE_BY_PARTNER_TRUNGVUONG}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'GET', headerConfig);
  }
  getFeatureTreeByPartner(headers) {
    const url = `${this.options.apiRoot}/${constants_1.GET_FEATURE_TREE_BY_PARTNER}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'GET', headerConfig);
  }
  paymentFeeSearchCodeV2(query, headers) {
    const queryString = utils_1.jsonToQueryString(query);
    const url = `${this.options.apiRoot}/${constants_1.PAYMENT_FEE_SEARCH_CODE_V2}?${queryString}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'GET', headerConfig);
  }
  paymentFeeSearchQRCode(data, headers) {
    const url = `${this.options.apiRoot}/${constants_1.PAYMENT_FEE_SEARCH_QR_CODE}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'POST', headerConfig, data);
  }
  paymentFeeSearchQRCodeV2(data, headers) {
    const url = `${this.options.apiRoot}/${constants_1.PAYMENT_FEE_SEARCH_QR_CODE_V2}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'POST', headerConfig, data);
  }
  reExam(data, headers) {
    const url = `${this.options.apiRoot}/${constants_1.RE_EXAM}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'POST', headerConfig, data);
  }
  reExamBookingTreeData(data, headers) {
    const url = `${this.options.apiRoot}/${constants_1.RE_EXAM_BOOKING_TREE_DATA}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'POST', headerConfig, data);
  }
  reExamSearch(data, headers) {
    const url = `${this.options.apiRoot}/${constants_1.RE_EXAM_SEARCH}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'POST', headerConfig, data);
  }
  updateBookingTelemedStatus(data, headers) {
    const url = `${this.options.apiRoot}/${constants_1.UPDATE_BOOKING_TELEMED_STATUS}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'POST', headerConfig, data);
  }
  sendBookingToMail(data, headers) {
    const url = `${this.options.apiRoot}/${constants_1.CSKH_SEND_MAIL}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'POST', headerConfig, data);
  }
  registerNotification(data, headers) {
    const url = `${this.options.apiRoot}/${constants_1.REGISTER_NOTIFICATION}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'POST', headerConfig, data);
  }
  updateUserDeviceNotification(data, headers) {
    const url = `${this.options.apiRoot}/${constants_1.UPDATE_DEVICE_USER_NOTIFICATION}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'POST', headerConfig, data);
  }
  getInsuranceInfo(data, headers) {
    const url = `${this.options.apiRoot}/${constants_1.GET_INSURANCE_INFO}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'POST', headerConfig, data);
  }
  getInvoices(data, headers) {
    const url = `${this.options.apiRoot}/${constants_1.TRACKING_ORDER_GET_INVOICES}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'POST', headerConfig, data);
  }
  sendMailInvoice(data, headers) {
    const url = `${this.options.apiRoot}/${constants_1.TRACKING_ORDER_SEND_MAIL}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'POST', headerConfig, data);
  }
  phoneRegisterMedproId(data, headers) {
    const url = `${this.options.apiRoot}/${constants_1.MEDPROID_PHONE_REGISTER}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'POST', headerConfig, data);
  }
  getEmployeeHIS(data, headers) {
    const url = `${this.options.apiRoot}/${constants_1.GET_EMPLOYEE_HIS}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'POST', headerConfig, data);
  }
  forgotPasswordMedproId(data, headers) {
    const url = `${this.options.apiRoot}/${constants_1.MEDPROID_FORGOT_PASSWORD}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'POST', headerConfig, data);
  }
  checkSMSCodeSignInProviderMedproId(data, headers) {
    const url = `${this.options.apiRoot}/${constants_1.MEDPROID_CHECK_SMS_CODE_SIGNIN_PROVIDER}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'POST', headerConfig, data);
  }
  checkSMSCodeForgotPasswordMedproId(data, headers) {
    const url = `${this.options.apiRoot}/${constants_1.MEDPROID_FORGOT_PASSWORD_CHECK_CODE}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'POST', headerConfig, data);
  }
  applyNewPasswordMedproId(data, headers) {
    const url = `${this.options.apiRoot}/${constants_1.MEDPROID_APPLY_NEW_PASSWORD}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'POST', headerConfig, data);
  }
  applySignInProviderMedproId(data, headers) {
    const url = `${this.options.apiRoot}/${constants_1.MEDPROID_APPLY_SIGNIN_PROVIDER}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'POST', headerConfig, data);
  }
  referralCodeExists(data, headers) {
    const url = `${this.options.apiRoot}/${constants_1.REFERRAL_CODE_CHECK_EXISTS}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'POST', headerConfig, data);
  }
  applySignInProviderCBYTMedproId(data, headers) {
    const url = `${this.options.apiRoot}/${constants_1.MEDPROID_APPLY_SIGNIN_PROVIDER_V3}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'POST', headerConfig, data);
  }
  uploadAvatar(data, headers) {
    const url = `${this.options.apiRoot}/${constants_1.USER_UPLOAD_AVATAR}`;
    const headerConfig = Object.assign({
      partnerid: this.options.partnerid,
      appid: this.options.appid,
      token: this.options.token,
      file: true
    }, headers);
    return utils_1.basicAuthRequest(url, 'POST', headerConfig, data);
  }
  uploadAvatarNotAuthen(data, headers) {
    const url = `${this.options.apiRoot}/${constants_1.USER_UPLOAD_AVATAR_NOT_AUTHEN}`;
    const headerConfig = Object.assign({
      partnerid: this.options.partnerid,
      appid: this.options.appid,
      token: this.options.token,
      file: true
    }, headers);
    return utils_1.basicAuthRequest(url, 'POST', headerConfig, data);
  }
  eventShareInfo(data, headers) {
    const url = `${this.options.apiRoot}/${constants_1.EVENT_SHARE_INFO}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'POST', headerConfig, data);
  }
  eventShareSubmit(data, headers) {
    const url = `${this.options.apiRoot}/${constants_1.EVENT_SHARE_SUBMIT}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'POST', headerConfig, data);
  }
  getDSHocVi(headers) {
    const url = `${this.options.apiRoot}/${constants_1.LAY_HOC_VI}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'POST', headerConfig, {});
  }
  getDSViTriCongViec(headers) {
    const url = `${this.options.apiRoot}/${constants_1.LAY_VI_TRI_CONG_VIEC}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'POST', headerConfig, {});
  }
  socialRegister(data, headers) {
    const url = `${this.options.apiRoot}/${constants_1.MEDPROID_APPLY_SIGNIN_PROVIDER}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'POST', headerConfig, data);
  }
  loginWithPasswordMedproId(data, headers) {
    const url = `${this.options.apiRoot}/${constants_1.MEDPROID_LOGIN_WITH_PASSWORD}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'POST', headerConfig, data);
  }
  loginWithPasswordMedproIdRoles(data, headers) {
    const url = `${this.options.apiRoot}/${constants_1.MEDPROID_LOGIN_WITH_PASSWORD_ROLES}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'POST', headerConfig, data);
  }
  loginWithSocialMedproId(data, headers) {
    const url = `${this.options.apiRoot}/${constants_1.MEDPROID_LOGIN_SOCIAL}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'POST', headerConfig, data);
  }
  paymentFeeTracking(headers) {
    const url = `${this.options.apiRoot}/${constants_1.PAYMENT_FEE_TRACKING}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'POST', headerConfig, {});
  }
  getHospitalListByAppId(query, headers) {
    const queryString = utils_1.jsonToQueryString(query);
    const url = `${this.options.apiRoot}/${constants_1.HOSPITAL_LIST_BY_APP_ID}?${queryString}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'GET', headerConfig);
  }
  getHospitalListByAppIdV2(headers) {
    const url = `${this.options.apiRoot}/${constants_1.HOSPITAL_LIST_BY_APP_ID_V2}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'GET', headerConfig);
  }
  getHospitalListChoRay(query, headers) {
    const queryString = utils_1.jsonToQueryString(query);
    const url = `${this.options.apiRoot}/${constants_1.HOSPITAL_LIST_BY_APP_ID_V2}?${queryString}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'GET', headerConfig);
  }
  getHospitalListByAppIdV3(query, headers) {
    const queryString = utils_1.jsonToQueryString(query);
    const url = `${this.options.apiRoot}/${constants_1.HOSPITAL_LIST_BY_APP_ID_V3}?${queryString}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'GET', headerConfig);
  }
  getHospitalListByAppIdV4(query, headers) {
    const queryString = utils_1.jsonToQueryString(query);
    const url = `${this.options.apiRoot}/${constants_1.HOSPITAL_LIST_BY_APP_ID_V4}?${queryString}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'GET', headerConfig);
  }
  getInsuranceDate(data, headers) {
    const url = `${this.options.apiRoot}/${constants_1.GET_INSURANCE_DATE}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'POST', headerConfig, data);
  }
  checkFilter(data, headers) {
    const url = `${this.options.apiRoot}/${constants_1.CHECK_FILTER}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'POST', headerConfig, data);
  }
  getFilterByStep(data, headers) {
    const url = `${this.options.apiRoot}/${constants_1.CHECK_FILTER}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'POST', headerConfig, data);
  }
  getNextStep(data, headers) {
    const url = `${this.options.apiRoot}/${constants_1.GET_NEXT_STEP}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'POST', headerConfig, data);
  }
  getFilterCheckSessionInfo(query, headers) {
    const queryString = utils_1.jsonToQueryString(query);
    const url = `${this.options.apiRoot}/${constants_1.GET_FILTER_CHECK_SESSION}?${queryString}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'GET', headerConfig);
  }
  parseAddress(data, headers) {
    const url = `${this.options.apiRoot}/${constants_1.GET_INSURANCE_PARSE_ADDRESS}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'POST', headerConfig, data);
  }
  // eslint-disable-next-line class-methods-use-this
  getStatus(bookingStatus, paymentStatus) {
    if (paymentStatus === 2 && bookingStatus === 1) {
      return 'Chưa khám';
    }
    if (paymentStatus === 4) {
      if (bookingStatus === 1) {
        return 'Hết hạn';
      }
    } else if (paymentStatus === 5) {
      if (bookingStatus === 1) {
        return 'Chờ xác nhận';
      }
    } else if (bookingStatus === 1) {
      return 'Chưa thanh toán';
    }
    return '';
  }
  userBusy(query, headers) {
    const queryString = utils_1.jsonToQueryString(query);
    const url = `${this.options.apiRoot}/${constants_1.USER_BUSY_BOOKING}?${queryString}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'GET', headerConfig);
  }
  appIdListPartner(headers) {
    const url = `${this.options.apiRoot}/${constants_1.APP_ID_LIST_PARTNER}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'GET', headerConfig);
  }
  appIdListFeature(headers) {
    const url = `${this.options.apiRoot}/${constants_1.APP_ID_LIST_FEATURE}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'GET', headerConfig);
  }
  appIdListPartnerHaveFeature(data, headers) {
    const url = `${this.options.apiRoot}/${constants_1.APP_ID_LIST_PARTNER_HAVE_FEATURE}/${data.featureId}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'GET', headerConfig);
  }
  appIdListPartnerByFeatureType(data, headers) {
    const url = `${this.options.apiRoot}/${constants_1.APP_ID_LIST_PARTNER_BY_FEATURE_TYPE}?featureType=${data.featureType}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'GET', headerConfig);
  }
  userLogout(data, headers) {
    const url = `${this.options.apiRoot}/${constants_1.USER_ACCOUNT_LOGOUT}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'POST', headerConfig, data);
  }
  feeSearchByPatientCode(data, headers) {
    const url = `${this.options.apiRoot}/${constants_1.FEE_SEARCH_BY_PATIENT_CODE}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'POST', headerConfig, data);
  }
  getMakeCallStatus(query, headers) {
    const queryString = utils_1.jsonToQueryString(query);
    const url = `${this.options.apiRoot}/${constants_1.GET_MAKE_CALL_STATUS}?${queryString}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'GET', headerConfig);
  }
  updateMakeCallStatus(data, headers) {
    const url = `${this.options.apiRoot}/${constants_1.UPDATE_MAKE_CALL_STATUS}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'POST', headerConfig, Object.assign({}, data));
  }
  uploadFile(data, headers) {
    const url = `${this.options.apiRoot}/${constants_1.UPLOAD_FILE}`;
    const headerConfig = Object.assign({
      partnerid: this.options.partnerid,
      appid: this.options.appid,
      token: this.options.token,
      file: true
    }, headers);
    return utils_1.basicAuthRequest(url, 'POST', headerConfig, data);
  }
  getPartnerReferral(headers) {
    const url = `${this.options.apiRoot}/${constants_1.PARTNER_REFERRAL}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'GET', headerConfig);
  }
  getInfoVaccineService(query, headers) {
    const queryString = utils_1.jsonToQueryString(query);
    const url = `${this.options.apiRoot}/${constants_1.ALL_VACCINE_SERVICE}?${queryString}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'GET', headerConfig);
  }
  getBookingsAndResults(data, headers) {
    const url = `${this.options.apiRoot}/${constants_1.GET_BOOKINGS_AND_RESULTS}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'POST', headerConfig, data);
  }
  validReExamDate(data, headers) {
    const url = `${this.options.apiRoot}/${constants_1.VALID_RE_EXAM_DATE}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'POST', headerConfig, data);
  }
  getHospitalReferral(data, headers) {
    const url = `${this.options.apiRoot}/${constants_1.GET_HOSPITAL_REFERRAL}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'POST', headerConfig, data);
  }
  registerClinic(data, headers) {
    const url = `${this.options.apiRoot}/${constants_1.REGISTER_CLINIC}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'POST', headerConfig, data);
  }
  getValidPatientsByUserIdV2(data, headers) {
    const url = `${this.options.apiRoot}/${constants_1.GET_PATIENTS_BY_USER_ID_V2}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'POST', headerConfig, data);
  }
  uploadFileClinic(data, headers) {
    const url = `${this.options.apiRoot}/${constants_1.UPLOAD_CLINIC}`;
    const headerConfig = Object.assign({
      partnerid: this.options.partnerid,
      appid: this.options.appid,
      token: this.options.token,
      file: true
    }, headers);
    return utils_1.basicAuthRequest(url, 'POST', headerConfig, data);
  }
  createUserMomo(data, headers) {
    const url = `${this.options.apiRoot}/${constants_1.CREATE_USER_MOMO}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'POST', headerConfig, data);
  }
  verifyCskhToken(headers) {
    const url = `${this.options.apiRoot}/${constants_1.VERIFY_CSKH_TOKEN}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'GET', headerConfig);
  }
  getAvailableDoctor(query, headers) {
    const queryString = utils_1.jsonToQueryString(query);
    const url = `${this.options.apiRoot}/${constants_1.GET_AVAILABLE_DOCTOR}?${queryString}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'GET', headerConfig);
  }
  updateBookingToSharePayment(data, headers) {
    const url = `${this.options.apiRoot}/${constants_1.UPDATE_BOOKING_TO_SHARE_PAYMENT}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'PATCH', headerConfig, data);
  }
  getAllPaymentMultiBooking(data, headers) {
    const url = `${this.options.apiRoot}/${constants_1.GET_ALL_PAYMENT_MULTI_BOOKING}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'POST', headerConfig, data);
  }
  getPaymentFeeHistory(headers) {
    const url = `${this.options.apiRoot}/${constants_1.GET_PAYMENT_FEE_HISTORY}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'GET', headerConfig);
  }
  getAllGuidePatient(data, headers) {
    const url = `${this.options.apiRoot}/${constants_1.GET_ALL_GUIDE_PATIENT}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'POST', headerConfig, data);
  }
  searchGuidePatient(data, headers) {
    const url = `${this.options.apiRoot}/${constants_1.SEARCH_GUIDE_PATIENT}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'POST', headerConfig, data);
  }
  getGuidePatientByCondition(query, headers) {
    const queryString = utils_1.jsonToQueryString(query);
    const url = `${this.options.apiRoot}/${constants_1.GET_GUIDE_PATIENT_BY_CONDITION}?${queryString}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'GET', headerConfig);
  }
  getCountrySupportBookingXnc(headers) {
    const url = `${this.options.apiRoot}/${constants_1.COUNTRY_SUPPORT_XNC}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'GET', headerConfig);
  }
  createPatientXnc(data, headers) {
    const url = `${this.options.apiRoot}/${constants_1.CREATE_PATIENT_XNC}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'POST', headerConfig, data);
  }
  getHospitalContentPage(query, headers) {
    const queryString = utils_1.jsonToQueryString(query);
    const url = `${this.options.apiRoot}/${constants_1.GET_CONTENT_PAGE_HOSPITAL}?${queryString}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'GET', headerConfig);
  }
  getPayment(query, headers) {
    const queryString = utils_1.jsonToQueryString(query);
    const url = `${this.options.apiRoot}/${constants_1.GET_PAYMENT}?${queryString}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'GET', headerConfig);
  }
  decodeShortLink(code, headers) {
    const url = `${this.options.apiRoot}/${constants_1.DECODE_SHORT_LINK}?code=${code}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'GET', headerConfig);
  }
  insertPatientIntoUserCskh(headers) {
    const url = `${this.options.apiRoot}/${constants_1.INSERT_PATIENT_INTO_USER_CSKH}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'POST', headerConfig, {});
  }
  getPatientsByPhoneCskh(data, headers) {
    const url = `${this.options.apiRoot}/${constants_1.GET_PATIENTS_BY_PHONE_CSKH}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'POST', headerConfig, data);
  }
  getPatientTracking(param, headers) {
    const queryString = utils_1.jsonToQueryString(param);
    const url = `${this.options.apiRoot}/${constants_1.GET_PATIENT_TRACKING}?${queryString}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'GET', headerConfig);
  }
  getBookingsByPatientCskh(headers) {
    const url = `${this.options.apiRoot}/${constants_1.GET_BOOKINGS_BY_PATIENT_CSKH}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'GET', headerConfig);
  }
  getHospitalsHISCskh(headers) {
    const url = `${this.options.apiRoot}/${constants_1.GET_HOSPITAL_LIST_HAVE_HIS_CSKH}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'GET', headerConfig);
  }
  updateBooking(data, headers) {
    const url = `${this.options.apiRoot}/${constants_1.UPDATE_BOOKING}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'POST', headerConfig, data);
  }
  getBookingUpdateHistory(query, headers) {
    const queryString = utils_1.jsonToQueryString(query);
    const url = `${this.options.apiRoot}/${constants_1.GET_BOOKING_UPDATE_HISTORY}?${queryString}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'GET', headerConfig);
  }
  getClinicGAReport(headers) {
    const url = `${this.options.apiRoot}/${constants_1.GET_CLINIC_GA_REPORT}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'GET', headerConfig);
  }
  getRelationTypeMedproV3(headers) {
    const url = `${this.options.apiRoot}/${constants_1.GET_RELATION_TYPE_MEDPRO_V3}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'GET', headerConfig);
  }
  getReExamsCskh(query, headers) {
    const queryString = utils_1.jsonToQueryString(query);
    const url = `${this.options.apiRoot}/${constants_1.GET_RE_EXAMS_CSKH}?${queryString}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'GET', headerConfig);
  }
  getPartnerInfo(headers) {
    const url = `${this.options.apiRoot}/${constants_1.GET_PARTNER_INFO}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'GET', headerConfig);
  }
  getByDomain(query, headers) {
    const queryString = utils_1.jsonToQueryString(query);
    const url = `${this.options.apiRoot}/${constants_1.GET_BY_DOMAIN}?${queryString}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'GET', headerConfig);
  }
  sendVerificationCode(data, headers) {
    const url = `${this.options.apiRoot}/${constants_1.USER_PHONE_VERIFICATION_CODE}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'POST', headerConfig, data);
  }
  checkTokenWithSignInProviderPhone(data, headers) {
    const url = `${this.options.apiRoot}/${constants_1.CHECK_TOKEN_WITH_SIGN_IN_PROVIDER_PHONE}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'POST', headerConfig, data);
  }
  getBookingBySmsCode(query, headers) {
    const queryString = utils_1.jsonToQueryString(query);
    const url = `${this.options.apiRoot}/${constants_1.CSKH_GET_BOOKING_BY_SMS_CODE}?${queryString}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'GET', headerConfig);
  }
  getAllCountry(headers) {
    const url = `${this.options.apiRoot}/${constants_1.GET_ALL_COUNTRY}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'GET', headerConfig);
  }
  getAllCancellationReason(headers) {
    const url = `${this.options.apiRoot}/${constants_1.GET_ALL_CANCELLATION_REASON}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'GET', headerConfig);
  }
  verifyForgotPasswordCheckToken(data, headers) {
    const url = `${this.options.apiRoot}/${constants_1.VERIFY_TOKEN_FORGOT_PASSWORD}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'POST', headerConfig, data);
  }
  getZaloAuthorizationCodeGrant(headers) {
    const url = `${this.options.apiRoot}/${constants_1.ZALO_AUTHORIZATION_CODE}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'GET', headerConfig);
  }
  getZaloUserAccessToken(data, headers) {
    const url = `${this.options.apiRoot}/${constants_1.ZALO_GET_ACCESS_TOKEN}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'POST', headerConfig, data);
  }
  getDistricts(query, headers) {
    const queryString = utils_1.jsonToQueryString(query);
    const url = `${this.options.apiRoot}/${constants_1.GET_ALL_DISTRICT}?${queryString}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'GET', headerConfig);
  }
  getNations(headers) {
    const url = `${this.options.apiRoot}/${constants_1.GET_ALL_NATION}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'GET', headerConfig);
  }
  getCities(query, headers) {
    const queryString = utils_1.jsonToQueryString(query);
    const url = `${this.options.apiRoot}/${constants_1.GET_ALL_CITY}?${queryString}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'GET', headerConfig);
  }
  getWards(query, headers) {
    const queryString = utils_1.jsonToQueryString(query);
    const url = `${this.options.apiRoot}/${constants_1.GET_ALL_WARD}?${queryString}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'GET', headerConfig);
  }
  getProfessions(headers) {
    const url = `${this.options.apiRoot}/${constants_1.GET_ALL_PROFESSION}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'GET', headerConfig);
  }
  validateBookingRulePatient(params, headers) {
    const url = `${this.options.apiRoot}/${constants_1.VALIDATE_BOOKING_RULE_PATIENT}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'POST', headerConfig, params);
  }
  deleteUserAccount(headers) {
    const url = `${this.options.apiRoot}/${constants_1.DELETE_USER_ACCOUNT}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'POST', headerConfig, {});
  }
  getPopup(headers) {
    const url = `${this.options.apiRoot}/${constants_1.POPUP}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'GET', headerConfig);
  }
  retrySyncBooking(data, headers) {
    const url = `${this.options.apiRoot}/${constants_1.RETRY_SYNC_BOOKING_V1}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'POST', headerConfig, data);
  }
  getMedproIdUserByToken(headers) {
    const url = `${this.options.apiRoot}/${constants_1.USER_DETAIL_INFO}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'GET', headerConfig);
  }
  seachService(data, headers) {
    const url = `${this.options.apiRoot}/${constants_1.SEARCH_SERVICE}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'POST', headerConfig, data);
  }
  getDoctorTelemed(data, headers) {
    const queryString = utils_1.jsonToQueryString(data);
    const url = `${this.options.apiRoot}/${constants_1.GET_DOCTOR_TELEMED}?${queryString}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'GET', headerConfig);
  }
  getDoctors(params, headers) {
    const queryString = utils_1.jsonToQueryString(params);
    const url = `${this.options.apiRoot}/${constants_1.GET_DOCTORS}?${queryString}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'GET', headerConfig);
  }
  getListDoctor(params, headers) {
    const queryString = utils_1.jsonToQueryString(params);
    const url = `${this.options.apiRoot}/${constants_1.GET_LIST_DOCTOR}?${queryString}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'GET', headerConfig);
  }
  getDoctorDetail(params, headers) {
    const url = `${this.options.apiRoot}/${constants_1.GET_DOCTOR_DETAIL}/${params === null || params === void 0 ? void 0 : params.doctorId}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'GET', headerConfig);
  }
  getFeatureInApp(headers) {
    const url = `${this.options.apiRoot}/${constants_1.GET_FEATURE_IN_APP}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'GET', headerConfig);
  }
  getPartnerByFeatureInApp(query, headers) {
    const queryString = utils_1.jsonToQueryString(query);
    const url = `${this.options.apiRoot}/${constants_1.GET_PARTNER_BY_FEATURE_IN_APP}?${queryString}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'GET', headerConfig);
  }
  getFeatureOfPartnerInApp(query, headers) {
    const queryString = utils_1.jsonToQueryString(query);
    const url = `${this.options.apiRoot}/${constants_1.GET_FEATURE_PARTNER_IN_APP}?${queryString}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'GET', headerConfig);
  }
  searchKeywords(headers) {
    const url = `${this.options.apiRoot}/${constants_1.SEARCH_KEYWORDS}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'GET', headerConfig);
  }
  getVersionText(headers) {
    const url = `${this.options.apiRoot}/${constants_1.GET_VERSION_TEXT}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'GET', headerConfig);
  }
  createTreeNode(data, headers) {
    const url = `${this.options.apiRoot}/${constants_1.CREATE_TREE_NODE}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'POST', headerConfig, data);
  }
  updateTreeNode(data, headers) {
    const url = `${this.options.apiRoot}/${constants_1.UPDATE_TREE_NODE}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'PUT', headerConfig, data);
  }
  deleteTreeNode(params, headers) {
    const url = `${this.options.apiRoot}/${constants_1.DELETE_TREE_NODE}/${params.id}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'DELETE', headerConfig);
  }
  getRootTreeNode(query, headers) {
    const queryString = utils_1.jsonToQueryString(query);
    const url = `${this.options.apiRoot}/${constants_1.GET_ROOT_TREE_NODE}?${queryString}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'GET', headerConfig);
  }
  getAllTreeNode(headers) {
    const url = `${this.options.apiRoot}/${constants_1.GET_ALL_TREE_NODE}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'GET', headerConfig);
  }
  getListPackage(query, headers) {
    const queryString = utils_1.jsonToQueryString(query);
    const url = `${this.options.apiRoot}/${constants_1.GET_ALL_SERVICES}?${queryString}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'GET', headerConfig);
  }
  getPackageDetail(query, headers) {
    const queryString = utils_1.jsonToQueryString(query);
    const url = `${this.options.apiRoot}/${constants_1.GET_SERVICE_DETAIL}?${queryString}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'GET', headerConfig);
  }
  patientCallDoctor(data, headers) {
    const url = `${this.options.apiRoot}/${constants_1.PATIENT_CALL_DOCTOR}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'POST', headerConfig, data);
  }
  getRequireAction(headers) {
    const url = `${this.options.apiRoot}/${constants_1.REQUIRE_ACTION}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'GET', headerConfig);
  }
  getExtraInfo(headers) {
    const url = `${this.options.apiRoot}/${constants_1.GET_HOSPITAL_EXTRA}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'GET', headerConfig);
  }
  getHospitalDetail(params, headers) {
    const url = `${this.options.apiRoot}/${constants_1.GET_HOSPITAL_DETAIL}/${params === null || params === void 0 ? void 0 : params.slug}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'GET', headerConfig);
  }
  getPhoneLocaleList(headers) {
    const url = `${this.options.apiRoot}/${constants_1.PHONE_LOCALE_LIST}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'GET', headerConfig);
  }
  getPhoneLocaleListPatient(headers) {
    const url = `${this.options.apiRoot}/${constants_1.PHONE_LOCALE_LIST_PATIENT}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'GET', headerConfig);
  }
  getDoctorDynamicLink(query, headers) {
    const queryString = utils_1.jsonToQueryString(query);
    const url = `${this.options.apiRoot}/${constants_1.GET_DOCTOR_DYNAMIC_LINK}?${queryString}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'GET', headerConfig);
  }
  findPatientHis(param, headers) {
    const url = `${this.options.apiRoot}/${constants_1.FIND_PATIENT_HIS}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'POST', headerConfig, param);
  }
  unlockBooking(param, headers) {
    const url = `${this.options.apiRoot}/${constants_1.UNLOCK_BOOKING}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'POST', headerConfig, param);
  }
  checkPhoneViewBooking(query, headers) {
    const queryString = utils_1.jsonToQueryString(query);
    const url = `${this.options.apiRoot}/${constants_1.CHECK_PHONE_VIEW_BOOKING}?${queryString}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'GET', headerConfig);
  }
  getServiceSubscriptionByPhone(query, headers) {
    const queryString = utils_1.jsonToQueryString(query);
    const url = `${this.options.apiRoot}/${constants_1.SERVICE_SUBSCRIPTION_BY_PHONE}?${queryString}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'GET', headerConfig);
  }
  getExaminationResult(param, headers) {
    const url = `${this.options.apiRoot}/${constants_1.GET_EXAMINATION_RESULT}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'POST', headerConfig, param);
  }
  getExaminationResultNoPatient(headers) {
    const url = `${this.options.apiRoot}/${constants_1.GET_EXAM_NO_PATIENT}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'GET', headerConfig);
  }
  getLimitFileSize(headers) {
    const url = `${this.options.apiRoot}/${constants_1.GET_LIMIT_FILE_SIZE}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'GET', headerConfig);
  }
  uploadFileExamResults(param, headers) {
    const url = `${this.options.apiRoot}/${constants_1.UPLOAD_FILE_EXAM_RESULTS}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'POST', headerConfig, param);
  }
  createQuickExamination(param, headers) {
    const url = `${this.options.apiRoot}/${constants_1.CREATE_QUICK_EXAMINATION}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'POST', headerConfig, param);
  }
  updateExaminationResult(param, headers) {
    const url = `${this.options.apiRoot}/${constants_1.UPDATE_EXAMINATION_RESULT}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'POST', headerConfig, param);
  }
  deleteExaminationResult(params, headers) {
    const url = `${this.options.apiRoot}/${constants_1.DELETE_EXAMINATION_RESULT}/${params.id}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'DELETE', headerConfig);
  }
  getMedproCare(params, headers) {
    const url = `${this.options.apiRoot}/${constants_1.GET_MEDPRO_CARE}/${params.partnerId}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'GET', headerConfig);
  }
  getMedproCareByRules(data, headers) {
    const url = `${this.options.apiRoot}/${constants_1.GET_MEDPRO_CARE}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'POST', headerConfig, data);
  }
  getMedproCareAfter(params, headers) {
    const url = `${this.options.apiRoot}/${constants_1.GET_MEDPRO_CARE_AFTER}/${params.partnerId}?transactionId=${params.transactionId}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'GET', headerConfig);
  }
  getAllPayment(body, headers) {
    const url = `${this.options.apiRoot}/${constants_1.GET_ALL_PAYMENT}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'POST', headerConfig, body);
  }
  getAllUserCs(headers) {
    const url = `${this.options.apiRoot}/${constants_1.GET_ALL_USER_CS}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'GET', headerConfig);
  }
  updateMedproCareInstructor(data, headers) {
    const url = `${this.options.apiRoot}/${constants_1.MEDPRO_CARE_INSTRUCTOR}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'PATCH', headerConfig, data);
  }
  trackingMedproCare(body, headers) {
    const url = `${this.options.apiRoot}/${constants_1.TRACKING_MEDPRO_CARE}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'POST', headerConfig, body);
  }
  syncPatientHisKiosk(body, headers) {
    const url = `${this.options.apiRoot}/${constants_1.SYNC_PATIENT_HIS_KIOSK}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'POST', headerConfig, body);
  }
  complainBooking(body, headers) {
    const url = `${this.options.apiRoot}/${constants_1.COMPLAIN_BOOKING}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'POST', headerConfig, body);
  }
  checkSyncBooking(body, headers) {
    const url = `${this.options.apiRoot}/${constants_1.CHECK_SYNC_BOOKING}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'POST', headerConfig, body);
  }
  // Đặt dịch vụ Care247 thanh toán sau áp dụng cho UMC1 và Da Liễu
  reserveMedproCare(body, headers) {
    const url = `${this.options.apiRoot}/${constants_1.RESERVE_MEDPRO_CARE}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'POST', headerConfig, body);
  }
  // Đặt dịch vụ Care247 thanh toán sau áp dụng cho UMC1 và Da Liễu khi cs gửi phiếu cho khách
  reserveMedproCareCskh(body, headers) {
    const url = `${this.options.apiRoot}/${constants_1.RESERVE_MEDPRO_CARE_CSKH}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'POST', headerConfig, body);
  }
  // Lấy danh mục đặt thêm giờ (3h)
  getMedproCareAddon(body, headers) {
    const url = `${this.options.apiRoot}/${constants_1.MEDPRO_CARE_ADDON}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'POST', headerConfig, body);
  }
  // Lấy danh mục đặt thêm giờ (3h) cskh
  getMedproCareAddonCskh(body, headers) {
    const url = `${this.options.apiRoot}/${constants_1.MEDPRO_CARE_ADDON_CSKH}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'POST', headerConfig, body);
  }
  // Thanh toán thêm giờ cho dịch vụ Care247
  reserveMedproCareAddon(body, headers) {
    const url = `${this.options.apiRoot}/${constants_1.RESERVE_MEDPRO_CARE_ADDON}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'POST', headerConfig, body);
  }
  // Thanh toán thêm giờ cho dịch vụ Care247 khi cs gửi phiếu cho khách
  reserveMedproCareAddonCskh(body, headers) {
    const url = `${this.options.apiRoot}/${constants_1.RESERVE_MEDPRO_CARE_ADDON_CSKH}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'POST', headerConfig, body);
  }
  // Bổ sung API kiểm tra BHYT theo id của patient
  checkInsuranceByPatient(body, headers) {
    const url = `${this.options.apiRoot}/${constants_1.CHECK_INSURANCE_BY_PATIENT}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'POST', headerConfig, body);
  }
  // Bổ sung API lấy thông tin dịch vụ Care247
  getMedproCareInformation(body, headers) {
    const url = `${this.options.apiRoot}/${constants_1.MEDPRO_CARE_INFORMATION}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'POST', headerConfig, body);
  }
  // Bổ sung API lấy thông tin dịch vụ Care247 cho cskh
  getMedproCareInformationCskh(body, headers) {
    const url = `${this.options.apiRoot}/${constants_1.MEDPRO_CARE_INFORMATION_CSKH}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'POST', headerConfig, body);
  }
  // CSKH hủy dịch vụ Care247
  cancelBookingMedproCare(body, headers) {
    const url = `${this.options.apiRoot}/${constants_1.CANCEL_BOOKING_MEDPRO_CARE}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'POST', headerConfig, body);
  }
  getUserConfigBtn(data, headers) {
    const url = `${this.options.apiRoot}/${constants_1.GET_USER_CONFIG_BTN}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'POST', headerConfig, data);
  }
  updateUserInformation(data, headers) {
    const url = `${this.options.apiRoot}/${constants_1.UPDATE_USER_INFORMATION}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'POST', headerConfig, data);
  }
  updateBookingCheckConvertUser(data, headers) {
    const url = `${this.options.apiRoot}/${constants_1.UPDATE_CHECK_OTP_CONVERT_USER}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'POST', headerConfig, data);
  }
  getCallBotCskhByPhone(data, headers) {
    const url = `${this.options.apiRoot}/${constants_1.GET_CALL_BOT_CSKH}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'POST', headerConfig, data);
  }
  getQuickNotifBookingPages(data, headers) {
    const url = `${this.options.apiRoot}/${constants_1.GET_QUICK_NOTIF_BOOKING_PAGES}`;
    const headerConfig = Object.assign(Object.assign({}, this.options), headers);
    return utils_1.basicAuthRequest(url, 'POST', headerConfig, data);
  }
}
exports.Client = Client;